module.exports = __webpack_public_path__ + "img/icon_VisitAthens.9d9e29b2.png";